<template>
  <info-card :title="$t('Flavor Profile')">
    <div
      class="d-flex flex-wrap mt-n5"
    >
      <v-checkbox
        v-for="profile in allFlavorProfiles"
        :key="profile.id"
        :label="profile.name"
        :value="profile.name"
        v-model="searchParams.selectedFlavorProfiles"
        hide-details
        multiple
        style="width:50%"
        @change="onChange"
      />
    </div>
  </info-card>
</template>

<script>
import InfoCard from '@/components/InfoCard'
import tagService from '@/services/tags'
export default {
  name: 'FlavorProfileFilter',
  components: {
    InfoCard
  },
  data: () => ({
    allFlavorProfiles: [],
    searchParams: {
      selectedFlavorProfiles: []
    }
  }),
  mounted () {
    // Get all pg_vg_ratios to use in autocomplete
    tagService.allByType('flavorprofile_vs')
      .then(data => { this.allFlavorProfiles = data.data.tags })
      .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
  },
  methods: {
    onChange () {
      this.$emit('change', this.searchParams)
    },
    reset () {
      this.searchParams = {
        selectedFlavorProfiles: []
      }
      this.onChange()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vapevault/filters/FlavorProfileFilter.vue